(function () {
  function initHeader() {
    const group = document.querySelector('.hn-header-group');
    if (!group || group.dataset.initialized === 'true') return;
    group.dataset.initialized = 'true';
    const header = group.querySelector('.hn-header');
    const hamburger = group.querySelector('.hn-header__hamburger');
    const mobileNav = document.getElementById('hn-mobile-nav');
    const closeBtn = mobileNav && mobileNav.querySelector('.hn-menu__close');
    const searchTrigger = group.querySelector('#hn-search-trigger');
    const searchDrawer = document.getElementById('hn-search-drawer');
    const searchClose = document.getElementById('hn-search-close');
    const searchOverlay = document.getElementById('hn-search-overlay');
    const searchInput = document.getElementById('hn-search-input');
    function updateOffsets() {
      const height = group.getBoundingClientRect().height;
      const promo = group.querySelector('.hn-promo-bar');
      const main = document.getElementById('MainContent');
      if (main) main.style.paddingTop = height + 'px';
      document.documentElement.style.setProperty('--hn-group-h', height + 'px');
      document.documentElement.style.setProperty('--hn-promo-h', (promo ? promo.getBoundingClientRect().height : 0) + 'px');
    }
    updateOffsets();
    if (window.ResizeObserver) new ResizeObserver(updateOffsets).observe(group);
    else window.addEventListener('resize', updateOffsets, { passive: true });
    window.addEventListener('scroll', function () { if (header) header.classList.toggle('is-scrolled', window.scrollY > 8); }, { passive: true });
    function closeMenu(restoreFocus = true) {
      if (!mobileNav || !hamburger) return;
      mobileNav.classList.remove('is-open'); mobileNav.setAttribute('aria-hidden', 'true'); mobileNav.inert = true;
      hamburger.setAttribute('aria-expanded', 'false'); document.body.classList.remove('hn-nav-open');
      if (restoreFocus) hamburger.focus();
    }
    if (hamburger && mobileNav) {
      hamburger.addEventListener('click', function () {
        mobileNav.inert = false; mobileNav.classList.add('is-open'); mobileNav.setAttribute('aria-hidden', 'false');
        hamburger.setAttribute('aria-expanded', 'true'); document.body.classList.add('hn-nav-open'); if (closeBtn) closeBtn.focus();
      });
      mobileNav.querySelectorAll('a').forEach(function (link) { link.addEventListener('click', function () { closeMenu(false); }); });
      if (closeBtn) closeBtn.addEventListener('click', function () { closeMenu(); });
      window.matchMedia('(min-width: 990px)').addEventListener('change', function (event) { if (event.matches) closeMenu(false); });
    }
    function closeSearch() {
      if (!searchDrawer) return;
      searchDrawer.classList.remove('is-open'); searchDrawer.setAttribute('aria-hidden', 'true'); searchDrawer.inert = true;
      if (searchTrigger) { searchTrigger.setAttribute('aria-expanded', 'false'); searchTrigger.focus(); }
      document.body.classList.remove('hn-nav-open');
    }
    if (searchDrawer) searchDrawer.inert = true;
    if (searchTrigger && searchDrawer) {
      searchTrigger.addEventListener('click', function () {
        closeMenu(false); searchDrawer.inert = false; searchDrawer.classList.add('is-open'); searchDrawer.setAttribute('aria-hidden', 'false');
        searchTrigger.setAttribute('aria-expanded', 'true'); document.body.classList.add('hn-nav-open'); if (searchInput) searchInput.focus();
      });
      if (searchClose) searchClose.addEventListener('click', closeSearch);
      if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);
    }
    document.addEventListener('keydown', function (event) {
      const activeDialog = mobileNav && mobileNav.classList.contains('is-open') ? mobileNav : searchDrawer && searchDrawer.classList.contains('is-open') ? searchDrawer : null;
      if (!activeDialog) return;
      if (event.key === 'Escape') { if (activeDialog === mobileNav) closeMenu(); else closeSearch(); }
      if (event.key !== 'Tab') return;
      const focusables = Array.from(activeDialog.querySelectorAll('a[href], button, input:not([type="hidden"]), select, [tabindex="0"]')).filter(function (element) { return !element.disabled && element.getClientRects().length; });
      if (!focusables.length) return;
      const first = focusables[0]; const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }
  initHeader(); document.addEventListener('shopify:section:load', initHeader);
})();
